import script from "./TableFields.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFields.vue?vue&type=script&setup=true&lang=js"

import "./TableFields.vue?vue&type=style&index=0&id=9d37a45c&lang=css"

const __exports__ = script;

export default __exports__